import React from 'react';
import { Fragment } from 'react';
import { Redirect } from 'react-router';
import Waiting from './waiting';
import { TackShape, WordShape } from '../shapes';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Person from './person';
import WordHeader from './word/header';

export default class LoggedOutTack extends React.Component {
  static propTypes = {
    tack: TackShape,
    word: WordShape,
    params: PropTypes.object,
    onReset: PropTypes.func,
    onLoggedOutTack: PropTypes.func
  }

  state = {
    email: undefined,
    isValidEmail: false
  }

  componentDidMount() {
    this.props.onReset();
  }

  render() {
    return (
      <div className='word'>
        <WordHeader wordText={this.props.params.wordText} pronunciationFile={this.props.word.get('pronunciationFile')} partOfSpeech={this.props.word.get('partOfSpeech')} mnemonicImageUrl={this.props.word.get('mnemonicImageUrl')} />
        { this.renderBody() }
      </div>
    );
  }

  renderBody() {
    if (this.props.tack.get('tackError')) {
      return this.renderTackError();
    } else if (this.props.tack.get('loading')) {
      return this.renderCreating();
    } else if (this.props.tack.get('wordText') === (this.props.params.wordText)) {
      return this.renderRedirect();
    } else {
      return this.renderPerson();
    }
  }

  renderOneMoreThing() {
    return (
      <div className='row email-explainer-section'>
        <div className='col-sm-12'>
          <p>
            Yak Tack uses a technique called "tacking" to help people remember words. We remind you of the definition every day or so at first, then
            less frequently as you get better at remembering it.
          </p>
          <p>
            Enter your email address below to create your account and start tacking <b>{ this.props.params.wordText }</b>.
            It's free. Oh, and we'll never spam you. Period.
          </p>
        </div>
      </div>
    );
  }

  renderPerson() {
    return(
      <Fragment>
        { this.renderOneMoreThing() }
        <Person email={ this.state.email } onEmailChange={ this.onEmailChange.bind(this) }></Person>
        <div className='clearfix'></div>
        <div className='row logged-out-tack'>
          <div className='col-sm-12'>
            <div className='action'>
              <Link to={ `/words/${ this.props.params.wordText }` } className='btn btn-outline-secondary'>Back</Link>
              { this.renderTackButton() }
            </div>
            <section className="give-me-55-top">
              <b>Our technique works. But don't take our word for it. We're featured in:</b>
              <div className='row give-me-30-top'>
                <div className='col-sm-4 as-seen-in give-me-15-down'>
                  <a href='https://www.makeuseof.com/best-websites-apps-that-improve-your-prose/'>
                    <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/make-use-of.png' className="as-seen-logo" alt="Make Use Of" />
                  </a>
                </div>
                <div className='col-sm-4 as-seen-in give-me-15-down'>
                  <a href='https://techcrunch.com/2021/04/15/yak-tack-is-a-super-simple-app-to-boost-vocabulary/'>
                    <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/tech-crunch.jpg' className="as-seen-logo" alt="TechCrunch" />
                  </a>
                </div>
                <div className='col-sm-4 as-seen-in'>
                  <a href='https://hackernoon.com/how-the-yak-tack-algorithm-helps-you-remember-words-dm1z34vb'>
                    <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/hackernoon-logo.png' className="as-seen-logo" alt="Hackernoon" />
                  </a>
                </div>
              </div>
            </section>              
          </div>        
        </div>
      </Fragment>
    );
  }

  renderTackButton() {
    if (this.state.isValidEmail) {
      return <button onClick={ this.onSaveEmail.bind(this) } className='btn btn-dark' type='button' data-primary-cta='true'>Tack</button>
    } else {
      return <button className='btn btn-dark disabled' type='button' data-primary-cta='true'>Tack</button>
    }
  }

  renderTackError() {
    return(
      <div className='error' >
        <div className='col-sm-12'>
          { `Hmm. ${ this.props.tack.get('tackError') }.` }
        </div>
        <div className='col-sm-12 action'>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Oops</Link>
        </div>
      </div>
    );
  }

  renderCreating() {
    return(
      <div className='item-meta'>
        <Waiting />
      </div>
    );
  }

  renderRedirect() {
    return (
      <Redirect push to={ `/tacks/logged_out/${this.props.params.wordText}/${this.props.params.targetLanguage}/confirmation` } />
    );
  }

  async onEmailChange(event) {
    const email = event.target.value.toLowerCase();
    await this.setState({ isValidEmail: this.isValidEmailSyntax(email) });
    this.setState({ email: email });
  }

  onSaveEmail() {
    this.props.onLoggedOutTack(this.props.params.wordText, this.state.email, this.props.params.targetLanguage);
  }

  isValidEmailSyntax(email) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
  }
}



// WEBPACK FOOTER //
// ./src/components/logged_out_tack.jsx